module.exports = __webpack_public_path__ + "static/media/Blondinette-min.bd0813ba.png";